import { render, staticRenderFns } from "./ShiftHandOverEdit.vue?vue&type=template&id=79204b6c&"
import script from "./ShiftHandOverEdit.vue?vue&type=script&lang=js&"
export * from "./ShiftHandOverEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports